import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Producers } from './pages/Producers';
import { ProducerDetail } from './pages/ProducerDetail';
import { SignIn } from './pages/auth/SignIn';
import { Register } from './pages/auth/Register';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { ResetPassword } from './pages/auth/ResetPassword';
import { EmailConfirmation } from './pages/auth/EmailConfirmation';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { FAQ } from './pages/FAQ';
import { AdminPortal } from './pages/admin/AdminPortal';
import { ProducerPortal } from './pages/producer/ProducerPortal';
import { UserPortal } from './pages/user/UserPortal';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import DriverRoute from './pages/driver/[routeId]';
import AdminOrdersPage from './pages/AdminOrdersPage';
import OrderAdmin from './components/admin/OrderAdmin';
import { AdminLayout } from './components/AdminLayout';
import { Dashboard } from './pages/admin/Dashboard';
import { Categories } from './pages/admin/Categories';
import { FAQs } from './pages/admin/FAQs';
import { Orders } from './pages/admin/Orders';
import { ProducersRouter } from './pages/admin/producers/ProducersRouter';
import EmailTemplateEditor from './pages/admin/email-templates';
import { Instructions } from './pages/admin/Instructions';
import { DeliverySlots } from './pages/admin/DeliverySlots';
import { Settings } from './pages/admin/Settings';
import { ToastProvider } from './components/ToastProvider';
import { ToastTest } from './components/ToastTest';
import { ProducerOnboarding } from './pages/producer/ProducerOnboarding';
import { SettingsProvider } from './contexts/SettingsContext';
import SupabaseDebug from './pages/admin/SupabaseDebug';

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <ToastProvider />
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="products" element={<Products />} />
              <Route path="products/:slug" element={<ProductDetail />} />
              <Route path="producers" element={<Producers />} />
              <Route path="producers/:id" element={<ProducerDetail />} />
              <Route path="cart" element={<Cart />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="order-confirmation/:orderId" element={<OrderConfirmation />} />
              <Route path="login" element={<SignIn />} />
              <Route path="auth/login" element={<SignIn />} />
              <Route path="auth/register" element={<Register />} />
              <Route path="auth/forgot-password" element={<ForgotPassword />} />
              <Route path="auth/reset-password" element={<ResetPassword />} />
              <Route path="auth/confirmation" element={<EmailConfirmation />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="reset-password" element={<ResetPassword />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="toast-test" element={<ToastTest />} />
              <Route path="profile" element={<Navigate to="/account/profile" replace />} />
              <Route path="account/*" element={
                <ProtectedRoute requiredRole="customer">
                  <UserPortal />
                </ProtectedRoute>
              } />
              <Route path="producer/*" element={
                <ProtectedRoute requiredRole="producer">
                  <ProducerPortal />
                </ProtectedRoute>
              } />
              <Route path="producer/onboarding" element={<ProducerOnboarding />} />
              <Route path="admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="orders/*" element={<Orders />} />
                <Route path="categories/*" element={<Categories />} />
                <Route path="producers/*" element={<ProducersRouter />} />
                <Route path="faqs/*" element={<FAQs />} />
                <Route path="email-templates" element={<EmailTemplateEditor />} />
                <Route path="instructions" element={<Instructions />} />
                <Route path="delivery-times" element={<DeliverySlots />} />
                <Route path="settings/*" element={<Settings />} />
                <Route path="supabase-debug" element={<SupabaseDebug />} />
              </Route>
            </Route>
            {/* Driver route - no layout wrapper for full-screen mobile experience */}
            <Route path="/driver/:routeId" element={<DriverRoute />} />
          </Routes>
        </Router>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;